import { render } from "./MultipleCheckbox.vue?vue&type=template&id=4ce5cd90"
import script from "./MultipleCheckbox.vue?vue&type=script&lang=js"
export * from "./MultipleCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/MultipleCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ce5cd90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ce5cd90', __exports__)) {
    api.reload('4ce5cd90', __exports__)
  }
  
  module.hot.accept("./MultipleCheckbox.vue?vue&type=template&id=4ce5cd90", () => {
    api.rerender('4ce5cd90', render)
  })

}


export default __exports__